// import * as Amplitude from '../../../expo-analytics-amplitude'
import {
  capitalizeEachWordStringUtil,
  logUtil
} from 'packages/src'
import getDataAnalyticsAction from '../get-data'
import { initAnalyticsUtil } from '../init'

// const Amplitude = {}
function logEventAnalyticsUtil (eventName, data) {
  try {
    initAnalyticsUtil()
    if (!eventName) {
      return
    }

    data = getDataAnalyticsAction(data)
    // const keys = Object.keys(data || {})
    // const name = keys.length === 1
    //   ? data[keys[0]]
    //   : getNameModelUtil(data)
    // TODO update when the following issue gets fixed:
    // @see {@link https://github.com/expo/expo/issues/5288}
    // if (!data || isAndroidEnvironmentUtil()) {
    // From `PLANS_ITEM_CLICKED` to `Plans Item Clicked`
    // if (name) {
    //   eventName = getActionStrReduxUtil(eventName, name + '')
    // }
    const formattedEventName = capitalizeEachWordStringUtil(eventName)
    logUtil('logEventAnalyticsUtil').debug(`[${formattedEventName}] data: `, data)
    // TODO use google analytics
    // if (!keys.length) {
    //   Amplitude.logEventAsync(formattedEventName)
    //   return
    // }
    // Amplitude.logEventWithPropertiesAsync(formattedEventName, data)
  } catch (error) {
    logUtil('').error(`logging event ${eventName} with data %o failed: `, data, error)
  }
}

export {
  logEventAnalyticsUtil
}
